import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popover-container"
}
const _hoisted_2 = {
  ref: "popoverContentRef",
  class: "popover-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("section", {
              class: "popover-toggle-container",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "popover-toggle" }, null, -1)
            ]))]),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}